import { Logger } from '@/core';

export const logger = new Logger();
